import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const initializeLazyScenarioStore = action(
    'INITIALIZE_LAZY_SCENARIO_STORE_NEXT',
    (scenarioId: SearchScenarioId, isUsing3S: boolean) => ({
        scenarioId,
        isUsing3S,
    })
);

export default initializeLazyScenarioStore;
